/*
 * View for the topic label list
 */

define([
  "marionette",
  "modules/shared/topicLabelList/template/topicLabelListTemplate.html",
], function (Marionette, TopicLabelListTemplate) {
  var TopicLabelListView = {};

  TopicLabelListView.topicLabelListLayout = Marionette.Layout.extend({
    template: TopicLabelListTemplate,
    className: "max-height",
    regions: {
      labelList: "#labelList",
    },
  });

  return TopicLabelListView;
});
